var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import API from "@irati/utils/services/API";
import client from "@irati/utils/services/apollo";
import PBService from "@irati/utils/services";
import endpoints from "../endpoints";
import getTenantFromPathHelper from "../helpers/getTenantFromPath";
import tenantErrorHandler from "./errors/legacy/tenantErrorHandler";
import tenantBySubdomainQuery, { tenantBySubdomainKey } from "./queries/tenantBySubdomain";
import tenantQuery, { tenantKey } from "./queries/tenant";
var TenantService = /** @class */ (function (_super) {
    __extends(TenantService, _super);
    function TenantService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getTenantBySubdomain = function (subdomain, options) {
            if (subdomain === void 0) { subdomain = getTenantFromPathHelper(); }
            if (options === void 0) { options = {}; }
            var variables = { subdomain: subdomain };
            return client.query(__assign(__assign({}, options), { query: tenantBySubdomainQuery, variables: variables })).then(function (_a) {
                var data = _a.data;
                return data[tenantBySubdomainKey];
            });
        };
        _this.get = function (businessId, options) {
            if (options === void 0) { options = {}; }
            var variables = {
                businessId: businessId,
                withRootTeam: false,
                withAdmins: false
            };
            return client.query(__assign(__assign({}, options), { query: tenantQuery, variables: variables })).then(function (res) { return res.data[tenantKey]; });
        };
        _this.requestTenant = function (tenant, options) {
            if (options === void 0) { options = {}; }
            if (tenant.uuid && !options.unAuth) {
                return _this.get(tenant.uuid, options);
            }
            if (tenant.subdomain) {
                return _this.getTenantBySubdomain(tenant.subdomain, options);
            }
            return Promise.reject("[RequestTenant]: No tenant identifier given");
        };
        _this.getSubdomainHistory = function (tenantId, options) {
            if (options === void 0) { options = {}; }
            return API.get("" + endpoints.subdomainHistory(tenantId), options).then(function (res) { return res.data; });
        };
        return _this;
    }
    return TenantService;
}(PBService));
var service = new TenantService({ errorHandlers: [tenantErrorHandler] });
export var getTenantBySubdomain = service.getTenantBySubdomain;
export var getTenant = service.get;
export var requestTenant = service.requestTenant;
export var getSubdomainHistory = service.getSubdomainHistory;
export default service;
